import { Box } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledTooltipWrapper = styled.div`
  position: relative;
`;

export const OnHoverOverlay = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(250, 250, 249, 0.8);
  opacity: 0;

  &:hover {
    opacity: 1;
  }
`;
